import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Magnetic wrapper for premium CTA hover
export function Magnetic({ children, strength = 0.35 }) {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - (r.left + r.width / 2)) * strength;
    const y = (e.clientY - (r.top + r.height / 2)) * strength;
    el.style.transform = `translate(${x}px, ${y}px)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = "translate(0,0)"; };
  return (
    <span ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} style={{ display: "inline-block", transition: "transform 0.25s ease" }}>
      {children}
    </span>
  );
}

export function CtaPrimary({ to, children, onClick, type, className = "", testId }) {
  const inner = (
    <span className={`cta-primary inline-flex items-center gap-3 px-8 py-4 font-mono-tech text-xs uppercase tracking-[0.2em] ${className}`}>
      {children}
      <span aria-hidden>→</span>
    </span>
  );
  if (to) return <Magnetic><Link to={to} data-testid={testId}>{inner}</Link></Magnetic>;
  return (
    <Magnetic>
      <button type={type || "button"} onClick={onClick} data-testid={testId}>{inner}</button>
    </Magnetic>
  );
}

export function CtaGhost({ to, children, onClick, className = "", testId }) {
  const inner = (
    <span className={`cta-ghost inline-flex items-center gap-3 px-8 py-4 font-mono-tech text-xs uppercase tracking-[0.2em] ${className}`}>
      {children}
    </span>
  );
  if (to) return <Link to={to} data-testid={testId}>{inner}</Link>;
  return <button type="button" onClick={onClick} data-testid={testId}>{inner}</button>;
}
